import {Box, Flex, HStack, Text, VStack} from "@chakra-ui/react";
import {Link} from "react-router-dom";
import {ReactComponent as Logo} from "../../assets/icons/footer_logo.svg";
import {ReactComponent as Xicon} from "../../assets/icons/x_icon.svg";
import {ReactComponent as Linkedin} from "../../assets/icons/linkedin_icon.svg";
import {ReactComponent as Telegram} from "../../assets/icons/telegram_icon.svg";
import {ReactComponent as CopyRight} from "../../assets/icons/copyright_icon.svg";

export const MobileFooter = () => {

    return (
        <Box
            as={'footer'}
            mt={'24px'}
            w={'full'}
            position={'relative'}
            overflow={'hidden'}>
            <VStack
                gap={'24px'}
                px={'20px'}>
                <VStack
                    gap={'24px'}
                    alignItems={'start'}
                    mt={'24px'}>
                    <Flex
                        justifyContent={'center'}
                        w={'100%'}>
                        <Logo/>
                    </Flex>
                    <Text
                        fontSize={'14px'}
                        color={'neutral.300'}>
                        Trade smarter, Grow faster
                    </Text>
                    <HStack
                        justifyContent={'center'}
                        w={'100%'}
                        gap={'12px'}>
                        <Xicon cursor={'pointer'}/>
                        <Linkedin cursor={'pointer'}/>
                        <Telegram cursor={'pointer'}/>
                    </HStack>
                </VStack>
                <VStack
                    gap={'24px'}
                    color={'neutral.300'}
                    w={'full'}
                    textAlign={'center'}
                    zIndex={'999'}>
                    <Link fontSize={'body.md'} to={'/'}>Home</Link>
                    <Link fontSize={'body.md'} to={'/about'}>About</Link>
                    <Link fontSize={'body.md'} to={'/features'}>Features</Link>
                    <Link fontSize={'body.md'} to={'/terms'}>Terms of Service</Link>
                    <VStack gap={'16px'}>
                        <Text fontSize={'body.lg'} color={'neutral.300'}>Contact Us</Text>
                        <Box>
                            <Text fontSize={'body.sm'} color={'#ffffff'}>+1 (406) 555-0120</Text>
                            <Text fontSize={'body.sm'} color={'#ffffff'}>+1 (480) 555-0103</Text>
                        </Box>
                        <Text fontSize={'body.sm'} color={'#ffffff'}>hellp@logoipsum.com</Text>
                    </VStack>
                </VStack>
            </VStack>
            <Flex
                mt={'50px'}
                fontSize={'body.xs'}
                justifyContent={'center'}
                w={'100%'}
                color={'neutral.600'}>
                <CopyRight/> 2025 Arbito. All Rights Reserved.
            </Flex>
        </Box>
    )
}